import React from "react";
import styled from "styled-components";
import img1 from "../../assets/images/snakes/1.jpg";
import img2 from "../../assets/images/snakes/2.jpg";
import img3 from "../../assets/images/snakes/3.jpg";
import img4 from "../../assets/images/snakes/4.jpg";
import img5 from "../../assets/images/snakes/5.jpg";
import img6 from "../../assets/images/snakes/6.jpg";
import img7 from "../../assets/images/snakes/7.JPG";
import img8 from "../../assets/images/snakes/8.JPG";
import img9 from "../../assets/images/snakes/9.JPG";
import img10 from "../../assets/images/snakes/10.JPG";
import img11 from "../../assets/images/snakes/11.JPG";
import img12 from "../../assets/images/snakes/12.JPG";
import img13 from "../../assets/images/snakes/13.JPG";
import img14 from "../../assets/images/snakes/14.JPG";
import img15 from "../../assets/images/snakes/15.JPG";
import SwiperSnakes from "../../components/homeComponents/swiperSnakes/SwiperSnakes";
import HowWork from "../../components/homeComponents/howWork/HowWork";
import { ContributingSection } from "../../components/homeComponents/contributing/ContributingSection";
import Features from "../../components/homeComponents/features/Features";
import Devices from "../../components/homeComponents/devices/Devices";
import SwiperExperts from "../../components/swiperExperts/SwiperExperts";
import DetectionPage from "../Detection/DetectionPage";
import { useSelector } from "react-redux";

const StyledHome = styled.section`
  /* height: 500px; */
  width: 100%;
`;
const Home = () => {
  const showLoader = useSelector((state) => state.loader.isLoading);
  return (
    <>
      <StyledHome>
      <SwiperSnakes images={[img1, img2, img3, img4, img5, img6, img7, img8, img9, img10, img11, img12, img13, img14, img15]} />
        {!showLoader && (
          <>
            <HowWork />
            <DetectionPage />
            <ContributingSection />
            <Features />
            <Devices />
            <SwiperExperts />
          </>
        )}
      </StyledHome>
    </>
  );
};

export default Home;
